<div class="controls-container">
    <div class="controls-header">Toast</div>

    <div class="controls-sub-header">Toast</div>

    <pm-button (Click)="CreateToast()">Create Toast</pm-button>

    <pm-button (Click)="CreateException()">Create Exception</pm-button>
</div>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/test/views/home/toast/toast.html